/* ============================================================================
   olmia-tracking.js — GA4 + Microsoft Clarity + Salesfeed voor Cobotwebshop.

   EEN POORT DIE BEPAALT WANNEER IETS GEBEURT IS GEEN POORT DIE BEPAALT OF HET
   MAG (ROADBLOCKS #57). Dit bestand houdt die twee daarom strikt uit elkaar:

     1. MAG HET?   -> Shopify Customer Privacy API. Drie toestanden:
                      true / false / null ("nog niet bekend"). Alleen `true`
                      laadt. Er is BEWUST geen tijdslimiet die alsnog laadt.
     2. WANNEER?   -> pas na de eerste interactie of na `requestIdleCallback`
                      (venster `vertraging`, standaard 2500 ms na `load`), zodat
                      er niets op de FCP/LCP-route staat.

   Vóór toestemming: geen enkel verzoek naar Google of Microsoft, geen cookie,
   geen localStorage, geen sessionStorage, geen `dataLayer`. Gebeurtenissen die
   in die tijd plaatsvinden gaan in een wachtrij IN HET GEHEUGEN; die verdwijnt
   bij het sluiten van het tabblad en wordt weggegooid zodra de bezoeker
   weigert.

   PRIJZEN (ROADBLOCKS #18). Een bedrag komt NOOIT uit een berekening in dit
   bestand en nooit uit een serverantwoord: het komt uitsluitend uit een
   `data-price`-attribuut in de DOM, en de server schrijft dat attribuut alleen
   wanneer déze bezoeker het bedrag mag zien. Ontbreekt het attribuut, dan gaat
   er geen `value` mee. Een QUOTE-product heeft dus per definitie geen bedrag in
   een gebeurtenis, ook niet voor een b2b-klant.

   Bronnen (gelezen 2026-08-21):
     shopify.dev/docs/api/customer-privacy
     shopify.dev/docs/api/web-pixels-api  (lax sandbox, geen DOM-toegang)
     developers.google.com/tag-platform/security/guides/consent  (Consent Mode v2)
     developers.google.com/analytics/devguides/collection/ga4/views
     learn.microsoft.com/clarity/setup-and-installation/clarity-consent-api-v2
     learn.microsoft.com/clarity/setup-and-installation/clarity-api
   ========================================================================== */
(function () {
  'use strict';

  /* Eén keer. Een tweede <script>-tag, een terugknop-herstel uit de bfcache of
     een sectie-herrender in de theme-editor mag NOOIT een tweede exemplaar
     starten — dat is de klassieke bron van dubbele gebeurtenissen. */
  if (window.OlmiaTracking) return;

  /* ---------------------------------------------------------------- config */

  var CFG = null;
  try {
    var el = document.getElementById('olmia-tracking-config');
    if (el && el.textContent.trim()) CFG = JSON.parse(el.textContent);
  } catch (e) { CFG = null; }
  if (!CFG) return;

  var GA4 = typeof CFG.ga4 === 'string' ? CFG.ga4.trim() : '';
  var CLARITY = typeof CFG.clarity === 'string' ? CFG.clarity.trim() : '';
  /* Salesfeed (Olmia's eigen account, ook op olmia-robotics.nl): de meetcode is
     één script van een eigen subdomein, bv. olmiarobotics.meeting8sync.nl.
     De instelling mag het kale adres zijn, een volledige URL of zelfs de hele
     <script>-tag; we halen er alleen de hostnaam uit, zodat er nooit iets anders
     dan https://<host>/ geladen kan worden.
     STRENGERE POORT DAN GA4/CLARITY (gemeten 2026-10-13 in het script zelf):
     Salesfeed leest e-mailadressen uit formuliervelden en cookies (gehasht naar
     Salesfeed, het domein leesbaar), maakt een browser-vingerafdruk en neemt
     sessies op (/v1/ingest). Dat is profilering voor verkoop, dus pas laden bij
     statistiek EN marketing. Opslag: localStorage zcl.2 en zss.1, geen cookies. */
  var SALESFEED = (function (v) {
    if (typeof v !== 'string') return '';
    var m = v.trim().match(/^(?:[\s\S]*?src=["']?)?(?:https?:)?(?:\/\/)?([a-z0-9-]+(?:\.[a-z0-9-]+)+)/i);
    return m ? m[1].toLowerCase() : '';
  })(CFG.salesfeed);
  if (!GA4 && !CLARITY && !SALESFEED) return;   // leeg ID = uit, en dus niets

  /* De theme-editor is geen bezoeker. Een merchant die zijn winkel inricht mag
     de cijfers niet vervuilen, en een sectie-herrender zou daar gebeurtenissen
     verdubbelen. */
  var DESIGN = !!(CFG.ontwerpmodus || (window.Shopify && window.Shopify.designMode));
  if (DESIGN) {
    window.OlmiaTracking = { uit: 'theme-editor', log: [], toestand: function () { return { reden: 'theme-editor' }; } };
    return;
  }

  /* `search.terms` komt bij Shopify HTML-ge-escaped uit Liquid: een bezoeker die
     "pick & place" zoekt levert de string `pick &amp; place`. Ongewijzigd
     doorsturen zou in GA4 twee zoektermen maken van één, en juist bij deze
     winkel zit er een & in ("Service & kits", "pick & place", "Boosters &
     Supports"). Gemeten 2026-08-21 op /search?q=pick%20%26%20place.
     Alleen deze vijf entiteiten kan Liquid's escape produceren; `&amp;` gaat
     als laatste, anders draait een dubbel ge-escapete string opnieuw om. */
  function ontHtml(t) {
    return String(t)
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;|&#x27;/g, "'")
      .replace(/&amp;/g, '&');
  }
  if (typeof CFG.zoekterm === 'string') CFG.zoekterm = ontHtml(CFG.zoekterm);

  var VALUTA = CFG.valuta || 'EUR';
  var VERTRAGING = Number(CFG.vertraging);
  if (!isFinite(VERTRAGING) || VERTRAGING < 0 || VERTRAGING > 20000) VERTRAGING = 2500;

  /* Welke toestemmingscategorie hoort hierbij?
     GA4 zet `_ga`/`_ga_<id>` (1e partij, 2 jaar) en Clarity zet `_clck`/`_clsk`
     (+ MUID/ANONCHK van Microsoft). Beide zijn STATISTIEK. De Shopify-poort
     daarvoor heet analyticsProcessingAllowed(). Advertentiesignalen (Consent
     Mode v2: ad_storage / ad_user_data / ad_personalization, en Clarity's
     ad_Storage) hangen apart aan marketingAllowed(); staat die op nee, dan
     blijven ze `denied` terwijl de statistiek gewoon draait. */
  var VEREIST = ['analytics'];

  /* --------------------------------------------------------------- toestand */

  var gestart = false;      // vendor-scripts geïnjecteerd
  var klaar = false;        // uitgestelde trigger is gevallen
  var peiling = null;
  var wachtrij = [];        // gebeurtenissen van vóór de start (alleen geheugen)
  var MAX_RIJ = 60;
  var log = [];             // meetlog voor scripts/verify-tracking.mjs
  var gedaan = {};          // dedupe-sleutels binnen deze paginalading
  var laatsteAdd = 0;       // tijdstip van de laatste in_winkelwagen

  /* ------------------------------------------------ Customer Privacy API --- */

  function cp() {
    try { return (window.Shopify && window.Shopify.customerPrivacy) || null; } catch (e) { return null; }
  }

  function lees(api, naam) {
    if (typeof api[naam] !== 'function') return null;
    try {
      var v = api[naam]();
      return typeof v === 'boolean' ? v : null;
    } catch (e) { return null; }
  }

  /* true = mag · false = mag niet · null = nog niet bekend.

     DE EXTRA POORT DIE DEZE WINKEL NODIG HAD. OPENSTAAND.md r127 legde vast dat
     de API hier ooit `{marketing:"yes", analytics:"yes", preferences:"yes"}`
     antwoordde terwijl `shouldShowBanner()` true was — de bezoeker had toen nog
     niets gekozen. Daarom is `shouldShowBanner() === true` hier hard "nog niet
     bekend", ongeacht wat de categorie-functies beweren. Een banner die nog
     open staat betekent per definitie: er is geen keuze gemaakt.
     (Gemeten 2026-08-21 op deze winkel: shouldShowBanner=true met alle drie de
     categorieën op false — de instelling is intussen goed. De poort blijft,
     want een instelling kan opnieuw wegzakken en wij zouden dat niet zien.) */
  function mag() {
    var api = cp();
    if (!api) return null;
    var banner = lees(api, 'shouldShowBanner');
    if (banner === null) return null;
    // `shouldShowBanner()` blijft op DEZE winkel `true` staan, ook nadat de bezoeker
    // heeft geklikt — gemeten 2026-08-21 op de echte storefront: drie verse browsers,
    // na accepteren en na een herlaadbeurt nog steeds true, terwijl
    // currentVisitorConsent() {marketing:"yes",analytics:"yes",preferences:"yes"} gaf.
    // Alleen op de banner grendelen betekende dus: nooit starten, voor niemand.
    // Daarom telt de banner alleen als "nog niet bekend" zolang er ook ECHT geen
    // keuze is vastgelegd. Zodra currentVisitorConsent() een categorie vult, ís er
    // gekozen en beslissen de categorie-functies — dat is de bron waar de
    // chat-widget al op vertrouwt (snippets/chat-widget.liquid r203).
    if (banner === true && !keuzeVastgelegd(api)) return null;
    var oordeel = true;
    for (var i = 0; i < VEREIST.length; i++) {
      var v = categorie(api, VEREIST[i]);
      if (v === null) return null;
      if (v !== true) oordeel = false;
    }
    return oordeel;
  }

  /* Is er daadwerkelijk een keuze vastgelegd? `currentVisitorConsent()` geeft vóór
     elke keuze lege strings ("") en daarna "yes"/"no" per categorie. Eén gevulde
     categorie is dus het bewijs dat de bezoeker heeft geklikt — onafhankelijk van
     wat shouldShowBanner() beweert. Kan de functie niet gelezen worden, dan
     antwoorden we `false` ("nog niets vastgelegd") en blijft de poort dicht:
     fail-closed, want niet-weten mag nooit tot tracking leiden. */
  function keuzeVastgelegd(api) {
    // NIET via lees(): die geeft uitsluitend booleans terug en `null` voor al het
    // andere, terwijl currentVisitorConsent() een OBJECT levert. Daarmee zou deze
    // functie altijd `false` antwoorden en bleef de poort eeuwig dicht.
    if (typeof api.currentVisitorConsent !== 'function') return false;
    var c;
    try { c = api.currentVisitorConsent(); } catch (e) { return false; }
    if (!c || typeof c !== 'object') return false;
    var velden = ['marketing', 'analytics', 'preferences', 'sale_of_data'];
    for (var i = 0; i < velden.length; i++) {
      var v = c[velden[i]];
      if (typeof v === 'string' && v !== '') return true;
    }
    return false;
  }

  function categorie(api, naam) {
    var fn = naam === 'marketing' ? 'marketingAllowed'
           : naam === 'preferences' ? 'preferencesProcessingAllowed'
           : 'analyticsProcessingAllowed';
    return lees(api, fn);
  }

  /* Advertentiesignalen: alleen bij een EXPLICIETE ja op marketing. Onbekend en
     nee gaan allebei naar `denied`. */
  function marketingMag() {
    var api = cp();
    if (!api) return false;
    // Zelfde grendel als in mag(): de banner alleen laten tellen zolang er geen
    // keuze is vastgelegd, anders staan de advertentiesignalen eeuwig op `denied`.
    if (lees(api, 'shouldShowBanner') === true && !keuzeVastgelegd(api)) return false;
    return categorie(api, 'marketing') === true;
  }

  function vraagApi() {
    if (cp()) { beslis(); return; }
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { beslis(); });
      }
    } catch (e) { /* geen API — beslis() houdt alles uit */ }
    /* Vangnet: de callback vuurt niet altijd als een ander script de feature al
       aan het laden was (chat-widget.liquid doet hetzelfde). Begrensd peilen,
       uitsluitend om te ONTDEKKEN dat de API er is — nooit om zonder antwoord
       alsnog te laden. */
    if (!peiling) {
      var pogingen = 0;
      peiling = setInterval(function () {
        pogingen++;
        if (cp()) { clearInterval(peiling); peiling = null; beslis(); }
        else if (pogingen > 120) { clearInterval(peiling); peiling = null; }   // 30 s
      }, 250);
    }
  }

  /* ------------------------------------------------------- besluitpunt ----- */

  function beslis() {
    var stand = mag();
    if (stand === true) {
      if (klaar) start();
      else if (gestart) { stuurToestemming(); startSalesfeed(); }   // marketing kan later nog wijzigen
      return;
    }
    /* Nee of nog-niet-bekend. Draaide het al, dan is de toestemming INGETROKKEN:
       de vendor-code zit in het geheugen en gaat er zonder navigatie niet meer
       uit, maar we kunnen wel alles opruimen wat hij op dit apparaat heeft
       neergezet en de signalen op `denied` zetten. Bij de volgende paginalading
       is er niets meer van over. Idempotent: opruimen bij ELK signaal. */
    if (gestart) opruimen();
    if (stand === false) wachtrij.length = 0;   // definitief nee: rij weggooien
  }

  /* --------------------------------------------------------------- starten - */

  function start() {
    if (gestart) return;
    if (mag() !== true) return;                 // de ENIGE poort naar het net
    gestart = true;
    if (GA4) startGA4();
    if (CLARITY) startClarity();
    startSalesfeed();
    stuurToestemming();
    var rij = wachtrij.slice();
    wachtrij.length = 0;
    for (var i = 0; i < rij.length; i++) verstuur(rij[i][0], rij[i][1]);
  }

  var sfGestart = false;
  function startSalesfeed() {
    if (!SALESFEED || sfGestart || !marketingMag()) return;
    sfGestart = true;
    injecteer('https://' + SALESFEED + '/');
  }

  function injecteer(src) {
    var s = document.createElement('script');
    s.async = true;
    s.src = src;
    var eerste = document.getElementsByTagName('script')[0];
    if (eerste && eerste.parentNode) eerste.parentNode.insertBefore(s, eerste);
    else document.head.appendChild(s);
  }

  function gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  function startGA4() {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') window.gtag = gtag;
    /* Consent Mode v2, in de door Google voorgeschreven volgorde: eerst
       `default` (alles denied), dan `update` met de gemeten stand, en PAS DAARNA
       gtag.js. Dat we hier überhaupt komen betekent al dat statistiek mag; de
       default-regel staat er zodat de volgorde klopt als Google ooit een
       categorie toevoegt die wij nog niet kennen. */
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
      wait_for_update: 500
    });
    window.gtag('js', new Date());
    /* send_page_view:false — wij sturen `page_view` zelf, met de Olmia-velden
       erbij. Zelfde gebeurtenisnaam, dus het rapport "Pagina's en schermen"
       blijft gewoon gevuld (developers.google.com/analytics/devguides/collection/ga4/views). */
    window.gtag('config', GA4, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false
    });
    injecteer('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA4));
  }

  function startClarity() {
    /* De officiële snippet, met één verschil: hij draait pas ná de poort. */
    (function (c, l, a, r, i) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      var t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(i);
      var y = l.getElementsByTagName(r)[0];
      if (y && y.parentNode) y.parentNode.insertBefore(t, y); else l.head.appendChild(t);
    })(window, document, 'clarity', 'script', CLARITY);
  }

  function stuurToestemming() {
    var ads = marketingMag();
    if (sfGestart && !ads) {
      try { ['zcl.2', 'zss.1'].forEach(function (k) { localStorage.removeItem(k); }); } catch (e) {}
    }
    if (GA4 && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: ads ? 'granted' : 'denied',
        ad_user_data: ads ? 'granted' : 'denied',
        ad_personalization: ads ? 'granted' : 'denied',
        analytics_storage: 'granted'
      });
    }
    if (CLARITY && typeof window.clarity === 'function') {
      window.clarity('consentv2', {
        ad_Storage: ads ? 'granted' : 'denied',
        analytics_Storage: 'granted'
      });
    }
  }

  /* ------------------------------------------------------------- opruimen -- */

  var COOKIES = [
    /^_ga($|_)/, /^_gid$/, /^_gat($|_)/, /^_gac_/, /^__utm/,
    /^_clck$/, /^_clsk$/, /^CLID$/, /^ANONCHK$/, /^MUID$/, /^SM$/, /^MR$/, /^MSPTC$/
  ];
  var OPSLAG = [/^_cltk$/i, /^clarity/i, /^_ga/i, /^zcl\./, /^zss\./];

  function opruimen() {
    gestart = false;
    try {
      if (GA4 && typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
          ad_storage: 'denied', ad_user_data: 'denied',
          ad_personalization: 'denied', analytics_storage: 'denied'
        });
      }
    } catch (e) {}
    try { if (CLARITY && typeof window.clarity === 'function') window.clarity('consent', false); } catch (e) {}
    var raak = function (naam) { for (var i = 0; i < COOKIES.length; i++) if (COOKIES[i].test(naam)) return true; return false; };
    try {
      document.cookie.split(';').forEach(function (c) {
        var n = c.split('=')[0].trim();
        if (!n || !raak(n)) return;
        document.cookie = n + '=; Max-Age=0; path=/';
        document.cookie = n + '=; Max-Age=0; path=/; domain=' + location.hostname;
        document.cookie = n + '=; Max-Age=0; path=/; domain=.' + location.hostname;
      });
      [localStorage, sessionStorage].forEach(function (bak) {
        for (var i = bak.length - 1; i >= 0; i--) {
          var k = bak.key(i);
          for (var j = 0; j < OPSLAG.length; j++) if (OPSLAG[j].test(k)) { bak.removeItem(k); break; }
        }
      });
    } catch (e) { /* private mode */ }
  }

  /* ------------------------------------------------------- gebeurtenissen -- */

  /* Vaste Nederlandse namen. `page_view` is de enige uitzondering en houdt zijn
     Google-naam, omdat GA4 daar zijn rapport "Pagina's en schermen" op bouwt;
     de Nederlandse naam reist mee in de parameter `olmia_gebeurtenis`, die in
     ELKE gebeurtenis zit. Zie specs/tracking-ga4-clarity.md hoofdstuk 4. */
  var NAMEN = {
    paginaweergave:          'page_view',
    product_bekeken:         'product_bekeken',
    in_winkelwagen:          'in_winkelwagen',
    winkelwagen_geopend:     'winkelwagen_geopend',
    afrekenen_gestart:       'afrekenen_gestart',
    keuzehulp_voltooid:      'keuzehulp_voltooid',
    opstelling_samengesteld: 'opstelling_samengesteld',
    offerte_aangevraagd:     'offerte_aangevraagd',
    zoekopdracht:            'zoekopdracht',
    filter_gebruikt:         'filter_gebruikt'
  };

  function meld(sleutel, params) {
    var naam = NAMEN[sleutel];
    if (!naam) return;
    var p = params || {};
    p.olmia_gebeurtenis = sleutel;
    p.sjabloon = CFG.sjabloon || '';
    p.ingelogd = CFG.ingelogd ? 'ja' : 'nee';
    p.klanttype = CFG.zakelijk ? 'zakelijk' : (CFG.ingelogd ? 'particulier' : 'gast');
    schoon(p);
    if (!gestart) {
      if (wachtrij.length < MAX_RIJ) wachtrij.push([naam, p]);
      return;
    }
    verstuur(naam, p);
  }

  /* Laatste zeef vóór het net: undefined/null/'' eruit, en een `value` of een
     `price` die niet eindig is gaat er ook uit. Zo kan een half berekend bedrag
     nooit als 0 of NaN de netwerktab in. */
  function schoon(p) {
    Object.keys(p).forEach(function (k) {
      var v = p[k];
      if (v === undefined || v === null || v === '') { delete p[k]; return; }
      if ((k === 'value' || k === 'price') && !(typeof v === 'number' && isFinite(v))) delete p[k];
    });
    if (Array.isArray(p.items)) {
      p.items.forEach(function (it) {
        Object.keys(it).forEach(function (k) {
          var v = it[k];
          if (v === undefined || v === null || v === '') { delete it[k]; return; }
          if (k === 'price' && !(typeof v === 'number' && isFinite(v))) delete it[k];
        });
      });
    }
  }

  function verstuur(naam, p) {
    /* HET ENIGE MOMENT WAAROP DIT BESTAND IETS OP HET APPARAAT ZET.
       verstuur() draait uitsluitend na `start()`, en `start()` draait
       uitsluitend bij mag() === true. Het slot tegen een dubbele lead moet
       hier staan en niet bij het waarnemen van de bevestiging: dat laatste
       gebeurt ook vóór toestemming, en dan mag er niets geschreven worden. */
    if (naam === 'offerte_aangevraagd') {
      try {
        var sl = 'olmia_tr_lead';
        var pad = location.pathname + location.search;
        if (sessionStorage.getItem(sl) === pad) return;   // al gemeld in dit tabblad
        sessionStorage.setItem(sl, pad);
      } catch (e) { /* private mode: dan alleen het slot binnen deze lading */ }
    }
    log.push({ naam: naam, params: p, t: Date.now() });
    if (log.length > 200) log.shift();
    try { if (GA4 && typeof window.gtag === 'function') window.gtag('event', naam, p); } catch (e) {}
    /* Clarity kent alleen een naam, geen parameters. De belangrijkste
       segmentatie gaat als custom tag mee (learn.microsoft.com/clarity → set). */
    try {
      if (CLARITY && typeof window.clarity === 'function') {
        window.clarity('event', naam);
        if (p.olmia_gebeurtenis === 'keuzehulp_voltooid' && p.advies) window.clarity('set', 'advies', String(p.advies));
        if (p.olmia_gebeurtenis === 'zoekopdracht' && p.search_term) window.clarity('set', 'zoekterm', String(p.search_term));
        if (p.olmia_gebeurtenis === 'filter_gebruikt' && p.filter) window.clarity('set', 'filter', String(p.filter));
      }
    } catch (e) {}
  }

  function eenmalig(sleutel) {
    if (gedaan[sleutel]) return false;
    gedaan[sleutel] = 1;
    return true;
  }

  /* --------------------------------------------------------- prijs uit DOM - */

  /* HET ENIGE PAD WAARLANGS EEN BEDRAG IN EEN GEBEURTENIS KAN KOMEN.
     De server schrijft `data-price` uitsluitend wanneer deze bezoeker het
     bedrag mag zien (main-product.liquid r666, product-card.liquid r154,
     opstelling-builder.liquid r190/r286). Geen attribuut = geen bedrag. */
  function bedragVan(el) {
    if (!el || !el.getAttribute) return null;
    var ruw = el.getAttribute('data-price');
    if (ruw === null || String(ruw).trim() === '') return null;
    var n = parseFloat(String(ruw).replace(',', '.'));
    if (!isFinite(n) || n < 0) return null;
    return Math.round(n * 100) / 100;
  }

  function afgeschermd(el) {
    return !!(el && el.getAttribute && el.getAttribute('data-op-gated') === '1');
  }

  function kaartData(kaart) {
    if (!kaart) return null;
    try {
      var ruw = kaart.getAttribute('data-product');
      return ruw ? JSON.parse(ruw) : null;
    } catch (e) { return null; }
  }

  /* --------------------------------------------------------- de tien haken - */

  function paginaweergave() {
    var p = {
      page_location: location.href,
      page_title: document.title,
      page_referrer: document.referrer || undefined
    };
    if (CFG.collectie) p.collectie = CFG.collectie;
    meld('paginaweergave', p);
    try {
      if (CLARITY && typeof window.clarity === 'function') {
        window.clarity('set', 'sjabloon', String(CFG.sjabloon || ''));
        window.clarity('set', 'klanttype', CFG.zakelijk ? 'zakelijk' : (CFG.ingelogd ? 'particulier' : 'gast'));
      }
    } catch (e) {}
  }

  function productBekeken() {
    var pr = CFG.product;
    if (!pr) return;
    var prijsEl = document.querySelector('[data-pdp-price][data-price]');
    var bedrag = bedragVan(prijsEl);
    var item = {
      item_id: String(pr.handle || pr.id || ''),
      item_name: pr.titel || '',
      item_brand: pr.merk || '',
      item_category: pr.categorie || ''
    };
    var p = { items: [item] };
    if (bedrag !== null) {
      item.price = bedrag;
      item.currency = VALUTA;
      p.value = bedrag;
      p.currency = VALUTA;
    } else {
      /* Geen bedrag zichtbaar. Dat is zélf een meetwaarde: Olmia wil weten hoe
         vaak een bezoeker op een offerte- of inlogmuur landt. */
      p.prijsmuur = 'ja';
    }
    meld('product_bekeken', p);
  }

  function inWinkelwagen(item, aantal, bedrag) {
    laatsteAdd = Date.now();
    var it = {
      item_id: item.item_id,
      item_name: item.item_name,
      item_brand: item.item_brand,
      item_category: item.item_category,
      quantity: aantal || 1
    };
    var p = { items: [it] };
    if (bedrag !== null && bedrag !== undefined) {
      it.price = bedrag;
      it.currency = VALUTA;
      p.value = Math.round(bedrag * (aantal || 1) * 100) / 100;
      p.currency = VALUTA;
    }
    meld('in_winkelwagen', p);
  }

  function keuzehulpAdvies() {
    var cta = document.getElementById('khCta');
    var href = cta ? (cta.getAttribute('href') || '') : '';
    var q = {};
    try {
      var vraag = href.indexOf('?');
      if (vraag >= 0) new URLSearchParams(href.slice(vraag + 1)).forEach(function (v, k) { q[k] = v; });
    } catch (e) {}
    var regels = [];
    document.querySelectorAll('#khLines .kh-line__t b').forEach(function (b) {
      var t = (b.textContent || '').trim();
      if (t) regels.push(t);
    });
    var advies = [q.cobot, q.gripper, q.vision].filter(Boolean).join(' + ');
    if (!advies && regels.length) advies = regels.join(' + ');
    if (!advies) return;
    /* Eén gebeurtenis per UNIEK advies. Een bezoeker die terugloopt en een
       antwoord wijzigt krijgt een nieuw advies en dus een nieuwe gebeurtenis;
       tweemaal hetzelfde advies is geen tweede voltooiing. */
    if (!eenmalig('kh:' + advies)) return;
    var titel = document.getElementById('khResultTitle');
    meld('keuzehulp_voltooid', {
      advies: advies,
      cobot: q.cobot || '',
      gripper: q.gripper || '',
      vision: q.vision || '',
      aantal_regels: regels.length,
      onderdelen: regels.join(' | '),
      advies_titel: titel ? (titel.textContent || '').trim() : ''
    });
  }

  function opstellingSamengesteld() {
    var wortel = document.querySelector('[data-opstelling]');
    if (!wortel) return;
    var kaart = wortel.querySelector('.cpick__card.active') || wortel.querySelector('.cpick__card');
    var opties = wortel.querySelectorAll('.bopt.active');
    var namen = [];
    var totaal = 0;
    var muren = 0;
    if (afgeschermd(kaart)) muren++;
    else { var b = bedragVan(kaart); if (b === null) muren++; else totaal += b; }
    for (var i = 0; i < opties.length; i++) {
      var o = opties[i];
      if (!o.getAttribute('data-variant')) continue;         // "Geen …"-optie
      var lbl = o.querySelector('.bopt__l');
      namen.push(lbl ? (lbl.textContent || '').trim() : (o.getAttribute('data-opt') || ''));
      if (afgeschermd(o)) { muren++; continue; }
      var bo = bedragVan(o);
      if (bo === null) muren++; else totaal += bo;
    }
    var p = {
      cobot: kaart ? (kaart.getAttribute('data-cobot') || '') : '',
      cobot_naam: kaart ? (kaart.getAttribute('data-title') || '') : '',
      onderdelen: namen.join(' | '),
      aantal_onderdelen: namen.length,
      afgeschermde_regels: muren
    };
    /* Bedrag alleen als ELKE regel voor deze bezoeker zichtbaar was. Eén
       afgeschermde regel en het totaal is niet meer het totaal dat hij ziet —
       dan gaat er geen bedrag mee (ROADBLOCKS #18: weglaten, niet verbergen). */
    if (muren === 0 && totaal > 0) { p.value = Math.round(totaal * 100) / 100; p.currency = VALUTA; }
    meld('opstelling_samengesteld', p);
  }

  function zoekopdracht(term, bron, resultaten) {
    var t = String(term || '').trim();
    if (t.length < 2) return;
    if (!eenmalig('zoek:' + bron + ':' + t.toLowerCase())) return;
    var p = { search_term: t, bron: bron };
    if (typeof resultaten === 'number' && isFinite(resultaten)) p.resultaten = resultaten;
    meld('zoekopdracht', p);
  }

  function offerteAangevraagd() {
    /* Slot binnen deze paginalading. Het tweede slot — over een herlaadbeurt
       heen — staat in verstuur(), want dat schrijft naar sessionStorage en dat
       mag pas ná toestemming. */
    if (!eenmalig('lead')) return;
    meld('offerte_aangevraagd', { formulier: 'contact', pad: location.pathname });
  }

  /* ------------------------------------------------------------- bindingen - */

  function bind() {
    /* Alles gedelegeerd op `document`, op attributen die al in het thema staan.
       Er wordt geen enkel bestand van een andere werkstroom aangeraakt. */

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // 1. in winkelwagen — productkaart (collectie, zoek, gerelateerd, campagne)
      var add = t.closest('[data-add]');
      if (add) {
        var kaart = add.closest('.pcard, [data-product]');
        var d = kaartData(kaart);
        if (d) {
          inWinkelwagen({
            item_id: d.handle || String(d.variantId || ''),
            item_name: d.title || '',
            item_brand: d.brand || '',
            item_category: d.category || ''
          }, 1, typeof d.price === 'number' ? d.price : null);
        }
        return;
      }

      // 2. in winkelwagen — productpagina (de knop bestaat alleen zonder muur)
      var pdp = t.closest('[data-pdp-add]');
      if (pdp) {
        var pr = CFG.product || {};
        var qty = document.querySelector('[data-pdp-qty]');
        var n = qty ? (parseInt(qty.value, 10) || 1) : 1;
        inWinkelwagen({
          item_id: String(pr.handle || pr.id || ''),
          item_name: pr.titel || '',
          item_brand: pr.merk || '',
          item_category: pr.categorie || ''
        }, n, bedragVan(document.querySelector('[data-pdp-price][data-price]')));
        return;
      }

      // 3. opstelling samengesteld (+ de bijbehorende toevoeging)
      if (t.closest('[data-bundle-add]')) { opstellingSamengesteld(); return; }

      // 4. winkelwagen geopend via een expliciete knop
      if (t.closest('[data-open-cart]')) { winkelwagenGeopend('knop'); return; }

      // 5. afrekenen gestart
      var af = t.closest('[data-drawer-checkout], [data-cart-page-checkout], a[href^="/checkout"], a[href*="/checkouts/"]');
      if (af) { meld('afrekenen_gestart', { vanaf: af.hasAttribute('data-drawer-checkout') ? 'lade' : 'winkelwagenpagina' }); return; }
    }, true);

    // 6. filter gebruikt + sortering
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el) return;
      if (el.matches && el.matches('input[type=checkbox][data-fkind]')) {
        var soort = el.getAttribute('data-fkind');
        meld('filter_gebruikt', {
          filter: soort === 'category' ? 'categorie' : soort === 'brand' ? 'merk' : soort === 'ip' ? 'beschermklasse' : soort,
          waarde: el.value || '',
          stand: el.checked ? 'aan' : 'uit',
          collectie: CFG.collectie || ''
        });
        return;
      }
      if (el.id === 'sortSelect') {
        meld('filter_gebruikt', { filter: 'sortering', waarde: el.value || '', stand: 'aan', collectie: CFG.collectie || '' });
        return;
      }
      var reeks = el.closest ? el.closest('.range[data-range]') : null;
      if (reeks && el.type === 'range') {
        var sleutel = reeks.getAttribute('data-range');
        var p = { filter: sleutel === 'payload' ? 'payload' : sleutel === 'reach' ? 'reikwijdte' : sleutel === 'price' ? 'prijs' : sleutel, stand: 'aan', collectie: CFG.collectie || '' };
        /* Geen getallen bij de PRIJS-schuif. De andere twee zijn kilo's en
           millimeters en dragen geen geld. */
        if (sleutel !== 'price') {
          var mn = reeks.querySelector('.r-min'), mx = reeks.querySelector('.r-max');
          if (mn && mx) p.waarde = Math.min(+mn.value, +mx.value) + '-' + Math.max(+mn.value, +mx.value);
        }
        meld('filter_gebruikt', p);
      }
    }, true);

    // 7. zoeken binnen de collectie (live veld) — rustig, na 900 ms stilte
    var tik = null;
    document.addEventListener('input', function (e) {
      var el = e.target;
      if (!el || el.id !== 'collSearch') return;
      clearTimeout(tik);
      tik = setTimeout(function () { zoekopdracht(el.value, 'collectie'); }, 900);
    }, true);

    // 8. winkelwagen geopend — de lade wordt ook door code geopend
    var lade = document.getElementById('cartDrawer');
    if (lade && window.MutationObserver) {
      var open = lade.classList.contains('open');
      new MutationObserver(function () {
        var nu = lade.classList.contains('open');
        if (nu && !open) winkelwagenGeopend('lade');
        open = nu;
      }).observe(lade, { attributes: true, attributeFilter: ['class'] });
    }

    // 9. keuzehulp voltooid — de sectie vuurt zelf geen gebeurtenis af, dus
    //    kijken we naar de stap die zichtbaar wordt (nooit een vreemd bestand
    //    aanpassen).
    var stap = document.querySelector('.kh__step[data-step="result"]');
    if (stap && window.MutationObserver) {
      var actief = stap.classList.contains('active');
      new MutationObserver(function () {
        var nu = stap.classList.contains('active');
        if (nu && !actief) setTimeout(keuzehulpAdvies, 60);
        actief = nu;
      }).observe(stap, { attributes: true, attributeFilter: ['class'] });
      if (actief) setTimeout(keuzehulpAdvies, 60);
    }

    // 10. offerte aangevraagd — het contactformulier post en komt terug met een
    //     server-bevestiging. Alleen die bevestiging telt als lead.
    var formulier = document.querySelector('form[action*="/contact"], #contactForm');
    if (formulier) {
      var kijk = function () {
        if (document.querySelector('.form-status--success')) { offerteAangevraagd(); return true; }
        return false;
      };
      if (!kijk() && window.MutationObserver) {
        var vak = formulier.parentNode || formulier;
        var mo = new MutationObserver(function () { if (kijk()) mo.disconnect(); });
        mo.observe(vak, { childList: true, subtree: true });
      }
    }
  }

  function winkelwagenGeopend(bron) {
    /* De lade springt zelf open na een toevoeging. Dat is dezelfde handeling,
       geen tweede stap in de trechter — anders zou "winkelwagen geopend" precies
       zo hoog staan als "in winkelwagen" en niets meer zeggen. */
    if (Date.now() - laatsteAdd < 1500) return;
    if (!eenmalig('cart:' + bron + ':' + Math.floor(Date.now() / 1500))) return;
    meld('winkelwagen_geopend', { bron: bron });
  }

  /* --------------------------------------------- uitgestelde trigger ------- */

  var gebeurtenissen = ['pointerdown', 'scroll', 'keydown'];
  var opties = { once: true, passive: true, capture: true };
  var wekker = null;

  function nuMag() {
    clearTimeout(wekker);
    gebeurtenissen.forEach(function (g) { window.removeEventListener(g, nuMag, opties); });
    if (klaar) return;
    klaar = true;
    beslis();
  }

  function plan() {
    if ('requestIdleCallback' in window) requestIdleCallback(nuMag, { timeout: VERTRAGING });
    else wekker = setTimeout(nuMag, VERTRAGING);
  }

  /* ----------------------------------------------------------------- init -- */

  function init() {
    bind();
    /* De paginaweergave wordt METEEN gemeld — hij gaat de wachtrij in en
       vertrekt pas als de poort open is. Zo is de meting niet afhankelijk van
       het moment waarop de bezoeker toestemming geeft. */
    paginaweergave();
    if (CFG.sjabloon === 'product') productBekeken();
    if (CFG.sjabloon === 'cart') winkelwagenGeopend('pagina');
    if (CFG.sjabloon === 'search' && CFG.zoekterm) {
      zoekopdracht(CFG.zoekterm, 'zoekpagina', typeof CFG.zoekresultaten === 'number' ? CFG.zoekresultaten : undefined);
    }
    vraagApi();
    document.addEventListener('visitorConsentCollected', function () { vraagApi(); beslis(); });
    gebeurtenissen.forEach(function (g) { window.addEventListener(g, nuMag, opties); });
    if (document.readyState === 'complete') plan();
    else window.addEventListener('load', plan, { once: true });
  }

  /* Meetvenster voor scripts/verify-tracking.mjs. Leest alleen; verandert niets. */
  window.OlmiaTracking = {
    log: log,
    wachtrij: wachtrij,
    toestand: function () {
      return {
        ga4: !!GA4, clarity: !!CLARITY, salesfeed: SALESFEED || false, salesfeedGestart: sfGestart,
        gestart: gestart, klaar: klaar,
        mag: mag(), marketing: marketingMag(),
        wachtrij: wachtrij.length, gemeld: log.length,
        vereist: VEREIST.slice()
      };
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
